import { exampleBusiness } from '../business/Business';
import { exampleUser, User } from '../user/User';

export interface UploadSubmission {
  id: number;

  displayName: string;

  businessID: number;
  businessName: string;

  uploadID: number;
  versionID: number;

  submittedUser?: User;
  reviewedUser?: User;

  approved: boolean;
  pending: boolean;
  message?: string;

  createdAt: string; // ISO Date
  updatedAt: string; // ISO Date

  aggregate: boolean;
}

export const exampleUploadSubmission: UploadSubmission = {
  id: 1,
  displayName: 'Test File',
  businessID: exampleBusiness.id,
  businessName: exampleBusiness.businessName,
  submittedUser: exampleUser,
  approved: false,
  pending: false,
  message: 'this data is horrible',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  aggregate: false,
  uploadID: 1,
  versionID: 1,
};
